module.exports = "data:text/x-markdown;base64,SW4gc29saWRpdHksIGZvciBhIGNvbnRyYWN0IHRvIGJlIGFibGUgdG8gcmVjZWl2ZSBldGhlciwgdGhlIGZhbGxiYWNrIGZ1bmN0aW9uIG11c3QgYmUgbWFya2VkICdwYXlhYmxlJy4KCkhvd2V2ZXIsIHRoZXJlIGlzIG5vIHdheSB0byBzdG9wIGFuIGF0dGFja2VyIGZyb20gc2VuZGluZyBldGhlciB0byBhIGNvbnRyYWN0IGJ5IHNlbGYgZGVzdHJveWluZy4gSGVuY2UsIGl0IGlzIGltcG9ydGFudCBub3QgdG8gY291bnQgb24gdGhlIGludmFyaWFudCBgdGhpcy5iYWxhbmNlID09IDBgIGZvciBhbnkgY29udHJhY3QgbG9naWMuCg=="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/force_complete.md
// module id = 1378
// module chunks = 0